<template lang="pug">
#relatorio-exportacao
    BaseHeader(
        :titulo='$t("relatorioExportacao.lista.titulo")',
        :exibeBotao='false'
    )

    .view-container.margen-bottom-pages
        .container-listagem
            RelatorioTotalizadores(
                :items='totalizadores'
                :loading='carregando'
            )
            RelatorioFiltros(
                @emitFiltros='emitFiltros'
            )
            .titulo-listagem
                h3 {{ $t("relatorioExportacao.lista.subTitulo")}}
            RelatorioTabela(
                :tabelaData='relatorios',
                :paginacao='params',
                :carregando='carregando',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import services from '@/modules/relatorio-exportacao/services/RelatorioService';
import RelatorioTabela from '@/modules/relatorio-exportacao/components/RelatorioTabela.vue';
import RelatorioFiltros from '@/modules/relatorio-exportacao/components/RelatorioFiltros.vue';
import RelatorioTotalizadores from '@/modules/relatorio-exportacao/components/RelatorioTotalizadores.vue';

export default {
    name: 'RelatorioExportacao',
    components: {
        BaseHeader,
        RelatorioTabela,
        RelatorioFiltros,
        RelatorioTotalizadores
    },

    data() {
        return {
            relatorios: [],
            totalizadores: [],
            params: {
                pagina: 0,
                itensPorPagina: 10,
                sort: 'id',
                por: 'desc'
            },
            carregando: false
        };
    },

    computed: {},
    mounted() {
        this.fetchRelatorios();
    },
    methods: {
        emitFiltros(filtros) {
            this.params = {
                ...this.params,
                ...filtros
            };
            this.fetchRelatorios();
        },
        fetchRelatorios() {
            this.carregando = true;

            services.fetchRelatorios(this.params).then(response => {
                this.relatorios = response.data.dados;
                this.params.total = response.data.meta.totalRegistros;
                this.params.pagina = response.data.meta.paginaAtual;
                this.totalizadores = Object.keys(response.data.meta).map(key => ({
                    id: key,
                    numero: response?.data?.meta?.[key]
                }));
            }).finally(() => {
                this.carregando = false;
            });
        },
        mudarPagina(pagina) {
            this.params.page = pagina;
            this.fetchRelatorios();
        },
        ordenarTabela({order, por}) {
            this.params.sort = order;
            this.params.por = por || 'desc';
            this.fetchRelatorios();
        }
    }
};
</script>

<style lang="scss">
#relatorio-exportacao {
    .container-listagem {
        margin-top: 20px;
    }
    .bloco-infor-dados {
        display: flex;
        justify-content: space-between;
        gap: 11px;
        width: 100%;
        flex-wrap: wrap;

        & > div {
            flex-grow: 1;
        }
    }
    .titulo-listagem h3 {
        font-weight: bold;
        margin: 20px 0;
    }
    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
}

.alertas-contratos-interno {
    display: flex;
    align-items: center;

    span {
        font-size: 22px;
        color: #3b3b3b;
        margin-right: 10px;
    }

    .link {
        color: #3fb1f2;
        margin-left: 6px;
        cursor: pointer;
        text-decoration: underline;
    }

    .link:hover {
        color: #ddac44;
    }
}

.alertas-enter-active,
.alertas-leave-active {
    transition: opacity 0.5s;
}

.alertas-enter,
.alertas-leave-to {
    opacity: 0;
}

@media only screen and (max-width: 1200px) {
    .bloco-infor-dados > div {
        width: 49%;
    }
}

.el-message-box {
    width: 50%;

    .el-message-box__btns {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .el-message-box__btns button:nth-child(2) {
        width: 200px !important;
    }
}
</style>
